export enum EDashboardSection {
  Overview = 1,
  Live,
  ParentOverview,
  PublicaAnalytics,
}

type DashboardSectionLabel = 'Overview' | 'Live' | 'Parent Overview' | 'Publica Analytics';

export interface IDashboardSection {
  label: DashboardSectionLabel;
  value: EDashboardSection;
  isParentPublisherOnly?: boolean;
  isPublicaOnly?: boolean;
}

export interface IDashboardsConfig {
  defaultState: {
    section: number;
  };
  sections: IDashboardSection[];
}

const dashboardSections: IDashboardSection[] = [
  { label: 'Overview', value: EDashboardSection.Overview },
  { label: 'Live', value: EDashboardSection.Live },
  {
    label: 'Parent Overview',
    value: EDashboardSection.ParentOverview,
    isParentPublisherOnly: true,
  },
  { label: 'Publica Analytics', value: EDashboardSection.PublicaAnalytics, isPublicaOnly: true },
];

export const dashboardsConfig: IDashboardsConfig = {
  defaultState: {
    section: EDashboardSection.Overview,
  },
  sections: dashboardSections,
};

export const findDashboardSectionByValue = (value: EDashboardSection) => {
  return dashboardSections.find((section) => value === section.value) || dashboardSections[0];
};
